var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',{attrs:{"gutter":24,"type":"flex"}},[_c('a-col',{staticClass:"mb-24",attrs:{"span":24}},[_c('CardTemplateTable',{attrs:{"data":_vm.templateData,"countries":_vm.countries},on:{"refresh":_vm.fetchTemplates}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }